import { ListBox } from "primereact/listbox";
import { DropdownChangesChecked } from "../Components/DropdownChangesChecked";
import { InputChangesChecked } from "../Components/InputChangesChecked";
import { useDepartmentList } from "../Persistence/DepartmentContext";
import { useCallback, useEffect, useState } from "react";
import { Button } from "primereact/button";
import { ConfirmDialog } from "../Components/ConfirmDialog";
import { Multiselect } from "../Components/Multiselect";
import { useOrganizationFunctionsSelectionList } from "../Persistence/OrganizationFunctionsContext";
import { useOperativeFunctionsSelectionList } from "../Persistence/OperativeFunctionsContext";
import { InputText } from "primereact/inputtext";
import { findData } from "../feathers";
import { ENUM_SERVICES } from "../Enums/ENUM_SERVICES";
import { Calendar } from "primereact/calendar";


export const emptyPerson = { id: null, version: 1, active: 1, lastname: '', firstname: '', roles: '', officePhoneNumber: '', G26Date: null, rfids: [], oldRfids: [], organizationFunctions: [], operativeFunctions: [] }

export const PersonForm = ({ formik }) => {
    const departmentList = useDepartmentList();
    const organizationFunctionsList = useOrganizationFunctionsSelectionList();
    const operativeFunctionnsList = useOperativeFunctionsSelectionList();
    const [selectedRfid, setSelectedRfid] = useState(null)
    const [deleteRfid, setDeleteRfid] = useState(null)
    const [displayConfirmDialog, setDisplayConfirmDialog] = useState(false);
    const [displayRFIDTagExistsDialog, setDisplayRFIDTagExistsDialog] = useState(false);
    const [newRFIDtag, setNewRFIDTag] = useState('');

    const checkNewRFIDTag = async () => {
        return await findData(ENUM_SERVICES.RFIDTAGS, { rfid: newRFIDtag }).then((result) => {
            return result && result.length > 0
        })
    }

    const removeRFIDTag = () => {
        if (deleteRfid) {
            const newRFidList = formik.values.rfids.filter(e => e.rfid !== deleteRfid.rfid)
            formik.handleChange({ target: { id: 'rfids', value: newRFidList } });
            setSelectedRfid(null)
        }
    }

    const selectedTemplateOperative = (option) => {
        const entry = option ? operativeFunctionnsList.find(e => e.id === option) : null;
        return entry ? <div className="w-full text-xm">{entry.name}</div> : '';
    }

    const selectedTemplateOrganization = (option) => {
        const entry = option ? organizationFunctionsList.find(e => e.id === option) : null;
        return entry ? <div className="w-full text-xm">{entry.name}</div> : '';
    }

    const itemTemplateRfid = useCallback((option) => {
        return <div className='flex'>
            <div className='flex flex-grow-1 align-items-center p-2'>{option.rfid}</div>
            {(!selectedRfid || option.rfid !== selectedRfid.rfid) ? '' :
                <i className='flex pi pi-trash align-items-center p-2' onClick={() => { setDeleteRfid(selectedRfid); setDisplayConfirmDialog(true) }} />}
        </div>
    }, [selectedRfid])


    return <div className='flex person-form'>
        <ConfirmDialog
            handleOnClick={removeRFIDTag}
            handleOnReject={() => setDisplayConfirmDialog(false)}
            labelCancel='Abbrechen'
            labelOk='Löschen'
            message={`Wollen Sie den RFID-Tag ${deleteRfid} wirklich löschen?`}
            title='Löschabfrage RFID-Tag'
            displayConfirmDialog={displayConfirmDialog}
            setDisplayConfirmDialog={setDisplayConfirmDialog}
        />
        <ConfirmDialog
            handleOnClick={e => { }}
            handleOnReject={() => setDisplayRFIDTagExistsDialog(false)}
            labelOk='OK'
            hideCancelButton={true}
            message={`RF-ID Tag mit der Nummer ${newRFIDtag} ist bereits im System vorhanden!`}
            title='RFID-Tag vorhanden'
            displayConfirmDialog={displayRFIDTagExistsDialog}
            setDisplayConfirmDialog={setDisplayRFIDTagExistsDialog}
        />
        <div className='flex flex-column col-6 align-content-start'>
            <InputChangesChecked id='firstname' className='mb-0' autoFocus={true} type="text" formik={formik} label='Vorname' setShowDialog={() => { }} />
            <InputChangesChecked id='lastname' tabIndex={0} type="text" formik={formik} label='Nachname' setShowDialog={() => { }} />
            <InputChangesChecked id='officePhoneNumber' tabIndex={0} type="text" formik={formik} label='Telefon' setShowDialog={() => { }} />
            <DropdownChangesChecked
                id='departmentId'
                editmode={true}
                label='Abteilung'
                formik={formik}
                itemLabel='name'
                itemValue='id'
                className={'bg-white w-full mb-3'}
                options={departmentList}
            />
            <div className="flex-grow-1 field px-2 mr-3">
                <div className='flex flex-row pb-2'>
                    <div className='flex flex-grow-1'>RFID-Tags</div>
                </div>
                <ListBox
                    id='rfids'
                    className=' w-full h-9rem overflow-auto'
                    value={selectedRfid}
                    options={formik.values.rfids}
                    onChange={(e) => setSelectedRfid(e.value)}
                    style={{ width: '15rem' }}
                    optionLabel='rfid'
                    itemTemplate={itemTemplateRfid} />
                <div className='flex flex-row pt-2 gap-2'>
                    <div className='flex justify-content-end align-content-end'>neuen Tag: </div>
                    <InputText
                        value={newRFIDtag}
                        onChange={(e) => {
                            setNewRFIDTag(e.target.value)
                        }}
                        className="flex-grow-1" />
                    <Button
                        disabled={newRFIDtag === ''}
                        onClick={async () => {
                            if (!await checkNewRFIDTag()) {
                                const newList = formik.values.rfids
                                newList.push({ rfid: newRFIDtag, personId: formik.values.id })
                                formik.handleChange({ target: { id: 'rfids', value: newList } });
                                setNewRFIDTag('')
                            } else {
                                setDisplayRFIDTagExistsDialog(true)
                            }
                        }}
                        label='hinzufügen'
                        icon='pi pi-plus'
                        className="font-bold"
                    />
                </div>
            </div>

        </div>
        <div className='col flex flex-column align-content-start'>
            <div className="flex flex-column field p-2 mr-3">
                <label htmlFor="G26">G26 gültig bis</label>
                <Calendar id="G26Date" value={formik.values.G26Date} onChange={(e) => { formik.handleChange(e) }} dateFormat="dd.mm.yy" />
            </div>
            <div className='flex h-10rem mb-2'>
                <Multiselect
                    id='organizationFunctions'
                    editmode={true}
                    label='Organisatorische Rollen'
                    formik={formik}
                    itemLabel='name'
                    itemValue='id'
                    className={'bg-white w-full'}
                    options={organizationFunctionsList}
                    selectedItemTemplate={selectedTemplateOrganization}
                    placeholder='keine Organisatorische Rolle'
                />
            </div>
            <div className='flex-grow-1'>
                <Multiselect
                    id='operativeFunctions'
                    editmode={true}
                    label='Operative Rollen'
                    formik={formik}
                    itemLabel='name'
                    itemValue='id'
                    className={'bg-white w-full'}
                    options={operativeFunctionnsList}
                    selectedItemTemplate={selectedTemplateOperative}
                    placeholder='keine Operative Rollen'
                />
            </div>
        </div>

    </div>
}

export const validatePerson = (data) => {
    let errors = {};

    if (!data.lastname) {
        errors.lastname = 'Nachname muss gesetzt sein';
    }
    if (!data.firstname) {
        errors.firstname = 'Vorname muss gesetzt sein';
    }
    if (!data.departmentId) {
        errors.departmentId = 'Abteilung muss gesetzt sein';
    }
    return errors;
}